import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { FiDownload } from "react-icons/fi";
import { numberToWords } from "../../../util/numberToWords";
import axios from "axios";
import { baseUrl } from "../../../api/common";

const PaymentReceiptForMobile = () => {

  const invoiceRef = useRef(null);
  const { slug } = useParams();
  const [invoiceData, setInvoiceData] = useState([]);
  const [memberDetails, setMemberDetails] = useState({});
  const [paymentDetails, setPaymentDetails] = useState({});
  const [applicationDetails, setApplicationDetails] = useState({});
  const fetchInvoiceDetails = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/invoice_data`,
        { id: slug },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      if (response.data.status) {
        const memberData = response.data.data[0];
        const paymentData = response.data.payment_status[0];
        const applicationData = response.data.application_data[0];
        setInvoiceData(response.data);
        setMemberDetails(memberData);
        setPaymentDetails(paymentData);
        setApplicationDetails(applicationData);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };


    const invoiceNumber = `INV-${memberDetails.application_no}`;
    const menberNumber = `${memberDetails.membership_no}`;
    const issueDate = moment().format("DD - MMM - YYYY");
    const dueDate = moment().add(2, "years").format("DD - MMM - YYYY");
  
    // Convert total price to words
    const amountInWords = numberToWords(applicationDetails.totalPrice);
  
    const handleDownloadPDF = () => {
      if (!invoiceRef.current) return;
  
      // Use html2canvas to capture the invoice as an image
      html2canvas(invoiceRef.current, {
        scale: 2,
        logging: false,
        useCORS: true,
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
  
        // Create PDF with proper dimensions (A4)
        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
        });
  
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
        const imgX = (pdfWidth - imgWidth * ratio) / 2;
        const imgY = 0;
  
        pdf.addImage(
          imgData,
          "PNG",
          imgX,
          imgY,
          imgWidth * ratio,
          imgHeight * ratio
        );
        pdf.save(
          `${memberDetails.first_name}-${memberDetails.application_no}-payment-receipt.pdf`
        );
      });
    };

    useEffect(() => {
      fetchInvoiceDetails();
    }, []);

    // Trigger auto-download on mobile when data is ready
    useEffect(() => {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        // if (isMobile && Object.keys(memberDetails).length > 0 && Object.keys(certificateDetails).length > 0) {
        if (Object.keys(invoiceData).length > 0 && Object.keys(memberDetails).length > 0 && Object.keys(applicationDetails).length > 0 && Object.keys(paymentDetails).length > 0) {
        handleDownloadPDF();
        }
    }, [invoiceData, memberDetails, applicationDetails,paymentDetails]);

    return (
        <div className="flex flex-col items-center">
        <div
            ref={invoiceRef}
            style={{
                width: "210mm",
                margin: "auto",
                padding: "20px",
                background: "#F1F5F9",
                fontFamily: "Arial, sans-serif",
                fontSize: "14px",
                borderRadius: "8px",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            }}
        >
            {/* Receipt Table */}
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: "14px",
                    background: "#fff",
                    borderRadius: "8px",
                    overflow: "hidden",
                }}
            >
                {/* Header */}
                <thead>
                    <tr>
                        <th
                            colSpan="4"
                            style={{
                                textAlign: "left",
                                padding: "20px",
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "#1E3A8A",
                                background: "#E2E8F0",
                                borderBottom: "2px solid #2563EB",
                            }}
                        >
                            <span
                                style={{
                                    borderLeft: "5px solid #2563EB",
                                    paddingLeft: "10px",
                                }}
                            >
                                Association of Minimal Access Surgeons of India (AMASI)
                            </span>
                        </th>
                    </tr>
                    <tr>
                        <th
                            colSpan="4"
                            style={{
                                textAlign: "center",
                                padding: "12px",
                                fontSize: "18px",
                                fontWeight: "bold",
                                color: "#fff",
                                background: "rgb(65 126 198)",
                                borderBottom: "2px solid #1E3A8A",
                            }}
                        >
                            PAYMENT RECEIPT
                        </th>
                    </tr>
                </thead>

                {/* Registration & Date Info */}
                <tbody>
                    <tr>
                        <td style={{ width: "50%", padding: "12px", verticalAlign: "top" }}>
                            <strong style={{ color: "#1E3A8A" }}>REGISTRATION NO:</strong>{" "}
                            <strong>{memberDetails.membership_no}</strong>
                            <br />
                            <strong style={{ fontSize: "16px" }}>
                            {memberDetails.salutation ? memberDetails.salutation : ""}
                            {memberDetails.first_name ? memberDetails.first_name : ""}
                            {memberDetails.middle_name ? " " + memberDetails.middle_name : ""}
                            {memberDetails.last_name ? " " + memberDetails.last_name : ""}
                            </strong>
                            <br />
                            <a
                                href={`mailto:${memberDetails.email}`}
                                style={{
                                    color: "#2563EB",
                                    textDecoration: "none",
                                    fontSize: "13px",
                                }}
                            >
                                {memberDetails.email}
                            </a>
                        </td>
                        <td
                            style={{
                                width: "50%",
                                padding: "12px",
                                textAlign: "right",
                                verticalAlign: "top",
                                fontSize: "14px",
                                color: "#444",
                            }}
                        >
                            <strong>Date:</strong>{" "}
                            <span style={{ fontWeight: "bold" }}>{issueDate}</span>
                            <br />
                            <strong>Amount Paid:</strong>{" "}
                            <span style={{ fontWeight: "bold", color: "#2563EB" }}>
                              ₹ {applicationDetails.totalPrice}
                            </span>
                        </td>
                    </tr>
                </tbody>

                {/* Payment Details Table */}
                <thead>
                    <tr style={{ background: "#E2E8F0", borderBottom: "2px solid #2563EB" }}>
                        <th style={{ textAlign: "left", padding: "12px", color: "#1E3A8A" }}>
                            DESCRIPTION
                        </th>
                        <th style={{ padding: "12px", textAlign: "center", color: "#1E3A8A" }}>
                            PRICE
                        </th>
                        <th style={{ padding: "12px", textAlign: "center", color: "#1E3A8A" }}>
                            QUANTITY
                        </th>
                        <th
                            style={{
                                padding: "12px",
                                textAlign: "center",
                                background: "rgb(65 126 198)",
                                color: "#fff",
                                fontSize: "14px",
                            }}
                        >
                            SUBTOTAL
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr style={{ borderBottom: "1px solid #ddd", background: "#F9FCFF" }}>
                        <td style={{ padding: "12px", color: "#2563EB" }}>
                        {applicationDetails.application_name}
                        </td>
                        <td style={{ padding: "12px", textAlign: "center" }}>₹ {applicationDetails.fee}/-</td>
                        <td style={{ padding: "12px", textAlign: "center" }}>1</td>
                        <td
                            style={{
                                padding: "12px",
                                textAlign: "center",
                                background: "#E2E8F0",
                                fontWeight: "bold",
                                color: "#1E3A8A",
                            }}
                        >
                           ₹ {applicationDetails.fee}/-
                        </td>
                    </tr>
                </tbody>

                {/* Fees Breakdown */}
                <tbody>
                    <tr>
                        <td colSpan="3" style={{ textAlign: "right", padding: "10px", borderBottom: "1px solid #ddd", color: "#666" }}>
                            Processing Fee
                        </td>
                        <td style={{ padding: "10px", textAlign: "center", borderBottom: "1px solid #ddd", color: "#333" }}>
                            ₹ {applicationDetails.processing_fee} /-
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="3" style={{ textAlign: "right", padding: "10px", borderBottom: "1px solid #ddd", color: "#666" }}>
                            GST {applicationDetails.gst_value}%
                        </td>
                        <td style={{ padding: "10px", textAlign: "center", borderBottom: "1px solid #ddd", color: "#333" }}>
                            ₹ {applicationDetails.gstAmount} /-
                        </td>
                    </tr>
                    <tr style={{ background: "#E2E8F0" }}>
                        <td colSpan="3" style={{ textAlign: "right", padding: "12px", fontSize: "16px", fontWeight: "bold", color: "#1E3A8A" }}>
                            GRAND TOTAL
                        </td>
                        <td style={{ padding: "12px", textAlign: "center", fontSize: "16px", fontWeight: "bold", background: "rgb(65 126 198)", color: "#fff" }}>
                            ₹ {applicationDetails.totalPrice} /-
                        </td>
                    </tr>
                </tbody>

                {/* Footer */}
                <tfoot>
                    <tr>
                        <td colSpan="4" style={{ textAlign: "left", padding: "20px", fontSize: "16px", fontWeight: "bold", color: "#333" }}>
                            Thank you!
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
        </div>
    );
};

export default PaymentReceiptForMobile;
